import React from "react";
import { PageProps } from "shared/page-props";
import * as Router from "react-router-dom";
import * as env from "shared/env";
import { AccountInfo } from "./account-info";
import { RefreshedAccountInfo } from "./account-info/refreshed";
import { AgentBio } from "./agent-bio";

interface Props extends PageProps, Router.RouteComponentProps {
}

class Component extends React.Component<Props> {

	public render() {
		const { user } = this.props;
		if (!user.admin) {
			return <AgentBio {...this.props} />;
		}
		return env.accountRefresh
			? <RefreshedAccountInfo {...this.props} />
			: <AccountInfo {...this.props} />;
	}

}

export const SettingsAccountPage = Component;